import {settingsActionTypes} from "../actions/settings-action-types";

const initialState = {
    attributes: {},
    systemProps: {},
    acceptedTerms: false
}

export const settings = (state = initialState, action) => {
    switch(action.type) {
        case settingsActionTypes.WEBCONFIG_RECEIVED:
            return {...action.webConfig };
        default: //We don't do anything with inflight settings yet
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/settings/reducers/webconfig-reducer.js